import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import Env, { BusIconTypeEnum } from '@ridango/core/env';

import { IconSizeEnum } from '../../../map/services/map-icon.utils';
import { MapApiService } from '../../services';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'rwidget-map-bus-icon',
    templateUrl: './map-bus-icon.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapBusIconComponent implements OnChanges {
    @Input() selectedBus;

    @Input() bus;

    @Input() enlargedMarkers = false;

    @Input() isBusSelected = false;

    @Input() generalBusIcon = false;

    @Input() zoomSize: IconSizeEnum;

    @Output() busClicked = new EventEmitter<any>();

    BUS_ICON_TYPE = BusIconTypeEnum;

    busTextClasses: Record<string, boolean>;

    constructor(
        @Inject('ENV') public env: Env,
        private mapApi: MapApiService
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.bus || changes.zoomSize || changes.isBusSelected) {
            this.setBusTextClasses();
        }
    }

    get markerColor(): string {
        return this.bus?.icon?.color || this.env.EXPLORE?.ICON_COLOR || 'var(--color-brand-primary)';
    }

    get markerTextColor(): string {
        return this.bus?.icon?.textColor || 'white';
    }

    get isShortNameBus(): boolean {
        return this.bus.route_short_name.length >= 3;
    }

    isMediumZoomLevel(zoom: IconSizeEnum): boolean {
        return zoom === IconSizeEnum.medium;
    }

    setBusTextClasses() {
        const routeShortNameLengthThree = this.bus.route_short_name.length === 3;
        this.busTextClasses = {
            'bus-text-more place-content-center': this.isShortNameBus,
            'vl-app-light:top-[calc(50%+2px)]': Capacitor.getPlatform() === 'android',
            'text-xxs': routeShortNameLengthThree,
            'text-[8px]':
                this.bus.route_short_name.length > 3 ||
                (routeShortNameLengthThree && this.isMediumZoomLevel(this.zoomSize)),
            'text-[7px]': this.bus.route_short_name.length > 3 && this.isMediumZoomLevel(this.zoomSize),
            'text-[10px]':
                this.isMediumZoomLevel(this.zoomSize) &&
                this.bus.route_short_name.length < 3 &&
                !this.selectedBus &&
                !this.isBusSelected,
            'dark:text-contrast-white': this.markerColor === '#000000',
            'dark:text-black': this.markerColor !== '#000000'
        };
    }

    onBusClicked(bus, event: Event) {
        this.busClicked.emit({ bus, event });
        this.mapApi.closePopup();
    }
}
